import { Routes, Route } from 'react-router-dom';
import { ChakraProvider, Flex, Box } from "@chakra-ui/react";
import Home from '../src/pages/Home/Home';
// import Poker from './pages/Battle/Battle';
import Rewards from './pages/Rewards/Rewards';
// import Pool from '../src/pages/Pool/Pool';
import FAQ from './pages/FAQ/FAQ';
// import Fantasy from '../src/pages/Fantasy/Fantasy';
import HowToPlay from './pages/HowItWorks.js/HowItWorks';
import Contact from '../src/pages/Contact/Contact';
import About from '../src/pages/About/About';
import Terms from "../src/pages/Terms/Terms"
import Privacy from '../src/pages/Privacy/Privacy';
import ResponsibleGaming from '../src/pages/ResponsiblePolicy/Responsible';
import FairPlay from '../src/pages/FairPlay/FairPlay';
import AntiMoney from '../src/pages/AntiMoney/antimoney';
import Community from '../src/pages/CommunityStandard/Community';
import Account from '../src/pages/AccountDelete/Privacy';
import Navbar from '../src/components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Tournaments from "./pages/Tournaments/tournaments";
import TournamentDetails from "./pages/Tournaments/TournamentDetails";
// import Game from "./pages/Games/Home";
import Ludo from "./pages/Games/Ludo";
import Poker from "./pages/Games/Poker";
import Pool from "./pages/Games/Pool";
import Rummy from "./pages/Games/Rummy";
import Cricket from "./pages/Games/Cricket";
 import Fantasy from "./pages/Games/Fantacy";
import './App.css';
import "swiper/css";
import "swiper/css/pagination";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Support from './pages/Contact/SupportForm';
import ScrollToTop from './ScrollTop';
import React, { useEffect } from "react";


 
function App() {
  useEffect(() => {
  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  document.addEventListener("contextmenu", handleContextMenu);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
  };
}, []);
  return (
    <ChakraProvider>
      <Flex direction="column" minHeight="100vh">
        <Navbar />
        
        <Box flex="1">
          <ScrollToTop />
          <Routes> 
            <Route path="/" element={<Home />} />
            <Route path="/games/casual-battles" element={<Poker />} />
            <Route path="/rewards-and-offers" element={<Rewards />} />
            <Route path="/games/pool" element={<Pool />} />
            <Route path="/faq" element={<FAQ />} />
            {/* <Route path="/games/fantasy" element={<Fantasy />} /> */}
            <Route path="/how-it-works" element={<HowToPlay />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/responsible-gaming-policy" element={<ResponsibleGaming />} />
            <Route path="/fair-play-policy" element={<FairPlay />} />
            <Route path="/community-standard" element={<Community />} />
            <Route path="/account-delete" element={<Account />} />
            <Route path="/anti-money-laundering-policy" element={<AntiMoney />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/games/ludo" element={<Ludo />} />
            <Route path="/games/poker" element={<Poker />} />
            <Route path="/games/pool" element={<Pool />} />
            <Route path="/tournament/prize" element={ <TournamentDetails />} />
            <Route path="/games/rummy" element={ <Rummy />} />
            <Route path="/games/cricket" element={<Cricket/>} />
            <Route path="/games/fantasy" element={<Fantasy/>} /> 
            <Route path='contact-us/form' element={<Support/>}/>
            
          </Routes>
        </Box>
        
        <Footer />
      </Flex>
    </ChakraProvider>
  );
}

export default App;
